var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.61297 16.3111V13.763C5.61297 13.1126 6.14413 12.5853 6.79935 12.5853H9.19449C9.50914 12.5853 9.8109 12.7094 10.0334 12.9302C10.2559 13.1511 10.3809 13.4507 10.3809 13.763V16.3111C10.3789 16.5816 10.4857 16.8416 10.6776 17.0335C10.8695 17.2254 11.1307 17.3334 11.4031 17.3333H13.0372C13.8003 17.3353 14.5329 17.0357 15.0733 16.5007C15.6136 15.9657 15.9173 15.2392 15.9173 14.4815V7.2224C15.9173 6.6104 15.644 6.02989 15.1712 5.63724L9.61234 1.22991C8.64537 0.457155 7.25991 0.482105 6.32181 1.28917L0.889828 5.63724C0.394602 6.01831 0.0986113 6.60055 0.0839844 7.2224V14.4741C0.0839844 16.0532 1.37347 17.3333 2.96413 17.3333H4.56089C5.12667 17.3334 5.58648 16.8802 5.59058 16.3185L5.61297 16.3111Z",
    fill: "#CFC8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.6dd7d84adb54a62a991a1cc2fe27273b.svg";
export { ForwardRef as ReactComponent };